<template>
  <v-container fluid grid-list-xl pa-0>
    <v-layout row wrap>
      <v-flex sm6 xs12 py-0>
        <app-breadcrumb title="Availability Mapping"></app-breadcrumb>
      </v-flex>
      <v-flex sm6 xs12 py-0>
        <div class="dropdown-filter-primary-group">
          <div class="dropdown-filter-primary">
            <v-autocomplete
              v-model="sellerSearch.model"
              :items="sellerSearchResults"
              :loading="sellerSearch.isLoading"
              :search-input.sync="sellerSearch.search"
              :ripple="false"
              background-color="rgba(48, 127, 255, 0.1)"
              clearable
              hide-details
              prepend-inner-icon="search"
              append-icon=""
              item-text="name"
              item-value="id"
              label="Search ..."
              solo
              flat
            >
              <template v-slot:item="{ item }">
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.name"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>
          </div>
          <div class="dropdown-filter-primary align-center f-auto ml-4">
            <v-checkbox v-model="noMapOnly" color="primary" label="Show only no mapping" :ripple="false"></v-checkbox>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="sellerMapping.sellerMaps.length > 0">
      <v-flex lg8 md8 sm12 xs12>
        <app-card>
          <div class="app-card-header">
            <div class="heading-block">
              <h4 class="heading">{{ sellerMapping.currentSeller.name }}</h4>
            </div>
          </div>
          <div class="card-body p-12">
            <!--{{ sellerMapping.sellerMaps }}-->
            <v-layout row wrap class="progress-steps" v-for="(item, i) in sellerMapping.sellerMaps" :key="i">
              <v-flex lg4 md3 xs12>
                <p>{{item.seller_text ? item.seller_text : 'Seller Text'}}</p>
              </v-flex>
              <v-flex lg8 md9 xs12>
                <v-radio-group @change="changeMapping($event, i, item.text_id)" ref="radioGroup" :value="item.mapping_id" row class="i-v-radio-group p-steps" hide-details>
                  <v-radio label="In Stock" value="0" :ripple="false" color="primary" class="i-v-radio light"></v-radio>
                  <v-radio label="Limited Stock" value="1" :ripple="false" color="warning" class="i-v-radio light"></v-radio>
                  <v-radio label="No Stock" value="2" :ripple="false" color="error" class="i-v-radio light"></v-radio>
                  <v-radio label="No Mapping" value="3" :ripple="false" color="dark" class="i-v-radio light"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </div>
        </app-card>
      </v-flex>
      <v-flex lg4 md4 sm12 xs12>
        <template v-if="sellerMapping.volumeDistribution.chartOptions.series.length > 0">
          <app-card :fill-height="false">
            <div class="app-card-header">
              <div class="heading-block">
                <h4 class="heading">Volume distribution</h4>
              </div>
            </div>
            <div class="card-body">
              <apexchart ref="chart" type="donut" class="volume-distribution-chart" height=280
                         :options="sellerMapping.volumeDistribution.chartOptions"
                         :series="sellerMapping.volumeDistribution.chartOptions.series"/>
            </div>
          </app-card>
        </template>
      </v-flex>
    </v-layout>

    <i-no-results v-else heading="Oops!" title="No matching Search Results" sub-title="Try to search for something with search filed above"></i-no-results>

    <!-- Option Save Toaster -->
    <notifications group="optionSaved" position="bottom right" :max="toaster.max" width="350">
      <template slot="body" slot-scope="props">
        <div class="default-notification save-notification">
          <a class="close" @click="props.close">
            <v-icon>close</v-icon>
          </a>
          <a class="title">
            <img src="../assets/img/icons/success.svg" alt="">
            {{ props.item.title }}
          </a>
          <p v-html="props.item.text"></p>
        </div>
      </template>
    </notifications>
  </v-container>
</template>
<script>
export default {
  name: 'AvailabilityMapping',
  data: () => ({
    sellerSearch: {
      isLoading: false,
      items: [],
      model: null,
      search: null
    },
    noMapOnly: false,
    mappingId: '',
    table: {
      headings: ['Seller', 'In stock', 'Limited Stock', 'No stock', 'No mapping'],
      rows: [
        {data: 'Seller Text Here'}
      ],
      rowsPerPageItems: [10, 25, 50, 100],
      pagination: {
        rowsPerPage: 25
      },
      loading: false,
      inStock: false,
      limitedStock: false,
      noStock: false,
      noMap: false
    },
    toaster: {
      max: 3
    }
  }),
  computed: {
    sellerSearchResults () {
      return this.$store.state.availabilityMappingModule.sellers
    },
    sellerMapping () {
      return this.$store.state.availabilityMappingModule
    }
  },
  watch: {
    'sellerSearch.search' (val) {
      if (val === '' || val === null) {
        return
      }
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      if (this.sellerSearchResults) {
        if (this.sellerSearchResults.find(el => val === el.name)) return
      }
      let vm = this
      this.timer = setTimeout(() => {
        this.sellerSearch.isLoading = true
        this.$store.dispatch('availabilityMappingModule/getSellers', {
          sellerName: val,
          pageId: 'map',
          no_map_only: vm.noMapOnly
        }).then(() => {
          this.sellerSearch.isLoading = false
        })
      }, 300)
    },
    'sellerSearch.model' (val) {
      if (val === '' || val === null) {
        this.sellerSearch.model = 0
        return
      }
      this.$store.dispatch('availabilityMappingModule/getSellerMapping', {
        sellerId: val
      }).then(() => {
        this.$refs.chart.refresh()
        this.$store.dispatch('availabilityMappingModule/getCurrentSeller', {
          name: this.sellerSearch.search,
          id: this.sellerSearch.model
        })
      })
    }
  },
  methods: {
    getSellerMapping () {
      return JSON.parse(JSON.stringify(this.sellerMapping.sellerMaps))
    },
    getRadioGroupModels () {
      return JSON.parse(JSON.stringify(this.sellerMapping.sellerMaps)).map(e => Number(e.mapping_id))
    },
    changeMapping (value, index, id) {
      this.$store.dispatch('availabilityMappingModule/getSaveMapping', {
        mappingId: value,
        textId: id,
        sellerId: this.sellerMapping.currentSeller.id
      }).then(() => {
        this.$notify({
          group: 'optionSaved',
          title: 'Availability Mapping',
          text: 'Option Saved !',
          duration: 500,
          speed: 600
        })
        this.$store.dispatch('availabilityMappingModule/getSellerMapping', {
          sellerId: this.sellerMapping.currentSeller.id
        })
      })
    }
  },
  destroyed () {
    this.$store.commit('availabilityMappingModule/RESET_sellerMapping')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/AvailabilityMapping.vue